module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h4', {
    staticClass: "title is-4"
  }, [_vm._v("Спасибо за ваш заказ.")]), _vm._v(" "), _c('p', [_vm._v("Ваш заказ "), _c('b', [_vm._v("№" + _vm._s(_vm.order.id))]), _vm._v(" оформлен. В скором времени с вами свяжется наш\n    менеджер для подтверждения заказа.")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-bfb00872"}!./~/vue-loader/lib/selector.js?type=template&index=0!./dev-packages/Shop/assets/site/widgets/order/FinishStep.vue
// module id = 648
// module chunks = 2